import axios from "@/api/axiosInstance";

export function toggleNotification(payload) {
  return axios.patch(`/api/v1/notifications`, payload);
}

export function fetchNotification() {
  return axios.get(`/api/v1/notifications`);
}
